// For Highlight Animations
function animateOnIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}

const options = {
  root: null,
  rootMargin: '40px',
  threshold: 0.7
};

const observer = new IntersectionObserver(animateOnIntersection, options);
const animatedElements = document.querySelectorAll('em.highlight-text');

animatedElements.forEach(element => {
  observer.observe(element);
});

// For Rotate Text Animations

jQuery('.dynamic-words').each(function() {
  var dynamicWords = jQuery(this);
  var textWraps = dynamicWords.find('.text-wrap');
  var currentIndex = 0;

  function updateWidth() {
    var activeWidth = dynamicWords.find('.text-wrap.active').width();
    console.log(activeWidth);
    dynamicWords.width(activeWidth);
  }

  textWraps.eq(currentIndex).addClass('active');

  setInterval(function() {
    textWraps.eq(currentIndex).removeClass('active');
    dynamicWords.css('width', '');
    currentIndex = (currentIndex + 1) % textWraps.length;

    textWraps.eq(currentIndex).addClass('active');

    updateWidth();
  }, 3000);
});

// For Underline Animations
function animateUnderlineOnIntersection(entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animated-underline');
    }
  });
}

const underlineOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5
};

const underlineObserver = new IntersectionObserver(animateUnderlineOnIntersection, underlineOptions);
const underlineElements = document.querySelectorAll('em.underline-animations');

underlineElements.forEach(element => {
  underlineObserver.observe(element);
});